import { defineComponent as o, createBlock as a, openBlock as n, normalizeProps as p, guardReactiveProps as l, withCtx as s, renderSlot as i, createElementVNode as m } from "vue";
import c from "../CdrIcon.vue.mjs";
const u = /* @__PURE__ */ o({
  name: "HeartFill",
  __name: "heart-fill",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (r, e) => (n(), a(c, p(l(t.props)), {
      default: s(() => [i(r.$slots, "default"), e[0] || (e[0] = m("path", {
        role: "presentation",
        d: "M12.702 20.712a.997.997 0 01-1.43-.026c-5.05-4.985-7.763-7.71-8.137-8.173C2.575 11.818 2 10.312 2 9a6 6 0 0110-4.472 6 6 0 018.701 8.2c-.542.683-3.208 3.344-8 7.984z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  u as default
};
